var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdea1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2140_15068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 20.3018V21.8908C14.8125 23.058 13.8704 24.0002 12.7031 24.0002H11.2969C10.1296 24.0002 9.1875 23.058 9.1875 21.8908V20.3018C9.1875 19.908 9.49683 19.5518 9.89062 19.5518H14.1094C14.5032 19.5518 14.8125 19.908 14.8125 20.3018Z",
    fill: "#FEA832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 5.67188C11.4938 5.67188 10.9876 5.72808 10.4813 5.85469C8.2313 6.375 6.41729 8.16089 5.8688 10.3969C5.32037 12.6468 5.95318 14.925 7.57032 16.514C8.14693 17.0906 8.48443 17.9484 8.48443 18.8766V19.0312C8.48443 20.1984 9.42657 21.1875 10.5938 21.1875H13.4063C14.5735 21.1875 15.5157 20.1984 15.5157 19.0312V18.8766C15.5157 17.9625 15.8672 17.0765 16.486 16.4718C17.6673 15.2765 18.3282 13.6875 18.3282 12C18.3282 8.4562 15.4595 5.67188 12.0001 5.67188Z",
    fill: "#FEDB41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53655 6.53057L3.54802 4.54204C3.27338 4.2674 3.27338 3.82242 3.54802 3.54778C3.82266 3.27314 4.26765 3.27314 4.54229 3.54778L6.53082 5.53631C6.80546 5.81095 6.80546 6.25593 6.53082 6.53057C6.25618 6.80526 5.81124 6.80526 5.53655 6.53057Z",
    fill: "#FEA832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5625 12.7031H0.703125C0.314484 12.7031 0 12.3886 0 12C0 11.6114 0.314484 11.2969 0.703125 11.2969H3.5625C3.95114 11.2969 4.26562 11.6114 4.26562 12C4.26562 12.3886 3.95114 12.7031 3.5625 12.7031Z",
    fill: "#FEA832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2969 12.7031H20.4375C20.0489 12.7031 19.7344 12.3886 19.7344 12C19.7344 11.6114 20.0489 11.2969 20.4375 11.2969H23.2969C23.6855 11.2969 24 11.6114 24 12C24 12.3886 23.6855 12.7031 23.2969 12.7031Z",
    fill: "#FE9923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4692 6.53057C17.1945 6.25593 17.1945 5.81095 17.4692 5.53631L19.4577 3.54778C19.7323 3.27314 20.1773 3.27314 20.452 3.54778C20.7266 3.82242 20.7266 4.2674 20.452 4.54204L18.4634 6.53057C18.1887 6.80526 17.7438 6.80526 17.4692 6.53057Z",
    fill: "#FE9923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7031 0.703125V3.5625C12.7031 3.9562 12.3938 4.26562 12 4.26562C11.6062 4.26562 11.2969 3.9562 11.2969 3.5625V0.703125C11.2969 0.309328 11.6062 0 12 0C12.3938 0 12.7031 0.309328 12.7031 0.703125Z",
    fill: "#FEA832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7031 0.703125V3.5625C12.7031 3.9562 12.3938 4.26562 12 4.26562V0C12.3938 0 12.7031 0.309328 12.7031 0.703125Z",
    fill: "#FE9923"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2140_15068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea1);
export default __webpack_public_path__ + "static/media/idea 1.d5a7c9b83acf472102b4758874e488ef.svg";
export { ForwardRef as ReactComponent };